import Breadcrumb, { BreadcrumbLevel } from '@andes/breadcrumb';
import { BreadcrumbLevelList } from '../../../utils/contracts';

interface BreadcrumbListProps {
  levels: Array<BreadcrumbLevelList>;
}

export const BreadcrumbList = ({ levels }: BreadcrumbListProps) => (
  <Breadcrumb srLabel="List of pages" className="breadcrumb-list">
    {levels.map(({ id, ...props }) => (
      <BreadcrumbLevel key={id} {...props} />
    ))}
  </Breadcrumb>
);
